import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1D4851",
      "stroke-width": "1.5",
      d: "M21.25 7.81v8.38c0 1.67-.495 2.915-1.32 3.74s-2.07 1.32-3.74 1.32h-5.44a.25.25 0 0 1-.25-.25V3a.25.25 0 0 1 .25-.25h5.44c1.67 0 2.915.495 3.74 1.32s1.32 2.07 1.32 3.74Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#1D4851",
      d: "M7.81 2a.44.44 0 0 1 .44.44v19.12a.44.44 0 0 1-.44.44C4.17 22 2 19.83 2 16.19V7.81C2 4.17 4.17 2 7.81 2"
    }, null, -1)
  ]))]))
}
export default { render: render }